import React from 'react';
import styles from './styles.css';
import {observer, inject} from 'mobx-react';
import routes from 'routes';

import ExpandableListItem from '../ExpandableListItem/ExpandableListItem';
import {List} from 'react-toolbox/lib/list';
import NavLink from 'components/NavLink/NavLink';

function SideDrawer({view, router, title}) {
  const renderMenu = () => {
    if (!view.isLoggedIn || !view.isAuthenticated) return <div></div>;
    return (
      <div>
        <List ripple>
          {Object.keys(routes).map(key => (
            <ExpandableListItem key={key} title={key}>
              {routes[key].map(route => (
                <NavLink key={route.pattern} route={route}/>
              ))}
            </ExpandableListItem>
          ))}
        </List>
      </div>
    )
  };

  return (
    <div className={styles.drawer}>
      <div
        className={styles.drawerBrand}
        onClick={() => router.navigate('/')}
      >
        {title}
      </div>
      <hr className={styles.divider}/>
      {renderMenu()}
    </div>
  );
}

export default inject('view', 'router')(observer(SideDrawer));



// WEBPACK FOOTER //
// ./src/components/SideDrawer/SideDrawer.js